import _container from "./container";
var exports = {};
let Container = _container;
class AtRule extends Container {
  constructor(defaults) {
    super(defaults);
    this.type = "atrule";
  }
  append(...children) {
    if (!this.proxyOf.nodes) this.nodes = [];
    return super.append(...children);
  }
  prepend(...children) {
    if (!this.proxyOf.nodes) this.nodes = [];
    return super.prepend(...children);
  }
}
exports = AtRule;
AtRule.default = AtRule;
Container.registerAtRule(AtRule);
export default exports;